import { useCallback } from 'react'
import { useCheckoutUrl } from './useCheckoutUrl'

declare global {
  interface Window {
    fbq?: (...args: any[]) => void
  }
}

export function useCheckoutHandler() {
  const checkoutUrl = useCheckoutUrl()

  const handleCheckout = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
      e.preventDefault()

      // Fire Meta Pixel AddToCart event if fbq is available
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'AddToCart', {
          content_ids: ['52757072314479'],
          content_type: 'product',
          value: 17.99,
          currency: 'USD',
        })
      }

      // Wait 300ms to ensure the pixel event is sent before redirecting
      setTimeout(() => {
        window.location.href = checkoutUrl
      }, 300)
    },
    [checkoutUrl],
  )

  return { checkoutUrl, handleCheckout }
}
